"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Marquee = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MarqueeImageTextItem = function MarqueeImageTextItem(_ref) {
  var image = _ref.image,
      text = _ref.text,
      style = _ref.style;
  return _react.default.createElement(_styles.StyledMarqueeItem, null, _react.default.createElement(_styles.ImageWithText, {
    src: image.src,
    srcSet: image.srcSet,
    alt: image.src,
    bold: style === 'bold'
  }), _react.default.createElement(_styles.Text, {
    bold: style === 'bold'
  }, text));
};

var Marquee = function Marquee(_ref2) {
  var images = _ref2.images,
      text = _ref2.text,
      style = _ref2.style;

  var renderImagesOnly = function renderImagesOnly() {
    return images.map(function (image, index) {
      return _react.default.createElement(_styles.Image, {
        key: "marquee-item--".concat(index),
        src: image.src,
        srcSet: image.srcSet,
        alt: image.src
      });
    });
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.StyledMarquee, {
    gradient: false,
    speed: 30
  }, text && (images === null || images === void 0 ? void 0 : images.length) > 0 && images.map(function (image, index) {
    return _react.default.createElement(MarqueeImageTextItem, {
      image: image,
      text: text,
      key: "marquee-item--".concat(index),
      style: style
    });
  }), (images === null || images === void 0 ? void 0 : images.length) > 0 && !text && renderImagesOnly()));
};

exports.Marquee = Marquee;